/* ChikenKoop custom JS — runs after Dawn JS */
(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 150;

  // Phrases that mark regulatory clutter inside product descriptions
  var CLUTTER_PATTERNS = [
    /^EU representative/i,
    /^Product information/i,
    /^Warnings,?\s*Hazard/i,
    /^Care instructions/i,
    /^Made in /i,
    /^Honson Ventures/i,
    /Directive 1999\/44\/EC/i,
    /Comfort Colors/i,
    /^Machine wash/i,
    /VIEW FULL DETAILS/i
  ];

  function looksLikeClutter(text) {
    if (!text) return false;
    var t = text.trim();
    if (!t) return false;
    return CLUTTER_PATTERNS.some(function (rx) { return rx.test(t); });
  }

  // === Inject "Details" header above product description ===
  function initProductDetailsHeader() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.ckHeaderInjected === '1') return;
    if (!desc.textContent.trim()) return;

    var header = document.createElement('h3');
    header.className = 'ck-product-details-header';
    header.textContent = 'Details';
    desc.parentNode.insertBefore(header, desc);
    desc.dataset.ckHeaderInjected = '1';
    desc.classList.add('ck-product-details-body');
  }

  // === Description scrubber: strip regulatory clutter only, keep all other content ===
  function scrubProductDescription() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.ckScrubbed === '1') return;

    // Kill structural clutter
    Array.prototype.slice.call(desc.querySelectorAll('table, hr, dl, blockquote, iframe, script')).forEach(function (t) { t.remove(); });

    // Walk every descendant element and remove ones matching known clutter phrases
    Array.prototype.slice.call(desc.querySelectorAll('p, div, h1, h2, h3, h4, h5, h6, span, strong, li')).forEach(function (el) {
      // Skip wrappers — only check leaf-ish elements
      if (el.querySelector('p, ul, ol, table')) return;
      var txt = (el.textContent || '').trim();
      if (txt && looksLikeClutter(txt)) {
        // If it's an LI inside a list, just remove the LI; otherwise remove the whole element
        el.remove();
      }
    });

    // Clean up any now-empty list wrappers
    Array.prototype.slice.call(desc.querySelectorAll('ul, ol')).forEach(function (ul) {
      if (!ul.children.length) ul.remove();
    });

    desc.dataset.ckScrubbed = '1';
  }

  // === Kill "View full details" link Dawn injects ===
  function killViewFullDetails() {
    Array.prototype.slice.call(document.querySelectorAll('a')).forEach(function (a) {
      var txt = (a.textContent || '').trim().toUpperCase();
      if (txt === 'VIEW FULL DETAILS' || txt === 'VIEW FULL DETAILS →') {
        a.style.display = 'none';
      }
    });
  }

  // === Inject live free-shipping progress bar (fills green, pulsates) below ADD TO CART ===
  function initShippingNote() {
    var btn = document.querySelector('.product-form__submit, .product-form button[type="submit"]');
    if (!btn || btn.dataset.ckShippingNoteInjected === '1') return;

    var note = document.createElement('div');
    note.className = 'ck-shipping-note';
    note.innerHTML =
      '<span class="ck-shipping-note__text"></span>' +
      '<span class="ck-shipping-note__bar" aria-hidden="true">' +
        '<span class="ck-shipping-note__bar-fill"></span>' +
      '</span>';
    var buttonsWrap = btn.closest('.product-form__buttons') || btn.parentNode;
    buttonsWrap.parentNode.insertBefore(note, buttonsWrap.nextSibling);
    btn.dataset.ckShippingNoteInjected = '1';
    updateShippingProgress();
  }

  function updateShippingProgress() {
    var note = document.querySelector('.ck-shipping-note');
    if (!note) return;
    var textEl = note.querySelector('.ck-shipping-note__text');
    var fill = note.querySelector('.ck-shipping-note__bar-fill');

    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var totalDollars = (cart.total_price || 0) / 100;
        var pct = Math.min(100, (totalDollars / FREE_SHIPPING_THRESHOLD) * 100);
        var remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - totalDollars);

        if (totalDollars >= FREE_SHIPPING_THRESHOLD) {
          textEl.textContent = "You've unlocked free shipping!";
          note.classList.add('ck-shipping-note--unlocked');
        } else if (totalDollars > 0) {
          textEl.textContent = '$' + remaining.toFixed(0) + ' away from free shipping';
          note.classList.remove('ck-shipping-note--unlocked');
        } else {
          textEl.textContent = 'Free shipping for orders over $' + FREE_SHIPPING_THRESHOLD;
          note.classList.remove('ck-shipping-note--unlocked');
        }
        fill.style.width = pct + '%';
      })
      .catch(function () {
        textEl.textContent = 'Free shipping for orders over $' + FREE_SHIPPING_THRESHOLD;
        fill.style.width = '0%';
      });
  }

  // === Paint color swatches based on the variant value text ===
  // Maps common color names + ChikenKoop-specific names to hex
  var COLOR_MAP = {
    'black': '#000000',
    'white': '#ffffff',
    'cream': '#F5EFDE',
    'natural': '#F5EFDE',
    'ivory': '#FFFFF0',
    'beige': '#F5F5DC',
    'tan': '#D2B48C',
    'sand': '#C2B280',
    'red': '#E11D2A',
    'crimson': '#E11D2A',
    'burgundy': '#800020',
    'maroon': '#800000',
    'pink': '#FFC0CB',
    'rose': '#FF66B2',
    'orange': '#FF8C00',
    'yellow': '#F4D03F',
    'gold': '#D4AF37',
    'green': '#1F8E3E',
    'olive': '#808000',
    'forest': '#228B22',
    'mint': '#98FF98',
    'sage': '#9CAF88',
    'teal': '#007D6F',
    'cyan': '#00BCD4',
    'blue': '#0F77D2',
    'navy': '#0D1B4F',
    'royal': '#1B45C7',
    'sky': '#87CEEB',
    'denim': '#1560BD',
    'purple': '#6A0DAD',
    'lavender': '#B39DDB',
    'lilac': '#C8A2C8',
    'gray': '#808080',
    'grey': '#808080',
    'charcoal': '#36454F',
    'slate': '#708090',
    'silver': '#C0C0C0',
    'brown': '#5D4037',
    'tobacco': '#704214',
    'khaki': '#C3B091'
  };

  function findHexFromText(text) {
    if (!text) return null;
    var t = text.toLowerCase().trim();
    // Direct match first
    if (COLOR_MAP[t]) return COLOR_MAP[t];
    // Strip brackets / parentheses / special chars
    t = t.replace(/[\[\]()]/g, '').trim();
    if (COLOR_MAP[t]) return COLOR_MAP[t];
    // Word-by-word match (e.g. "vintage wash black" → "black")
    var words = t.split(/\s+/);
    for (var i = words.length - 1; i >= 0; i--) {
      if (COLOR_MAP[words[i]]) return COLOR_MAP[words[i]];
    }
    return null;
  }

  function paintColorSwatches() {
    var fieldsets = document.querySelectorAll(
      '.product-form__input[data-option-name="Color" i], ' +
      '.product-form__input[data-option-name="Colour" i]'
    );
    fieldsets.forEach(function (fs) {
      var labels = fs.querySelectorAll('label');
      labels.forEach(function (label) {
        var input = fs.querySelector('input[id="' + label.getAttribute('for') + '"]');
        var valueText = '';
        if (input) {
          valueText = input.value || input.getAttribute('value') || '';
        }
        if (!valueText) {
          // Try the .swatch-input__label-text span
          var textSpan = label.querySelector('.swatch-input__label-text, .visually-hidden');
          valueText = (textSpan ? textSpan.textContent : '') ||
                      label.getAttribute('aria-label') ||
                      label.textContent || '';
        }
        valueText = valueText.trim();
        var hex = findHexFromText(valueText);
        if (!hex) return;

        // Paint EVERY possible "circle" element + set Dawn's CSS variable
        var paintTargets = [label].concat(
          Array.prototype.slice.call(label.querySelectorAll('.swatch, .ck-swatch, .swatch-input__label, span'))
        );
        paintTargets.forEach(function (el) {
          el.style.setProperty('background-color', hex, 'important');
          el.style.setProperty('background', hex, 'important');
          el.style.setProperty('background-image', 'none', 'important');
          el.style.setProperty('--swatch--background', hex);
          el.style.setProperty('--swatch-input--background', hex);
          // Strip the .swatch--unavailable class so Dawn's stripe pattern doesn't apply
          el.classList.remove('swatch--unavailable');
        });
        // Light colors get a darker outer ring for visibility
        if (/^#(F|E)/i.test(hex)) {
          label.style.boxShadow = 'inset 0 0 0 2px #ffffff, 0 0 0 1px rgba(0,0,0,0.4)';
        }
      });
    });
  }

  // === Replace "Unavailable" / "Variant sold out or unavailable" with "Sold Out" ===
  function relabelUnavailable() {
    // Replace text inside any visible "Unavailable" / "Sold out" labels and submit buttons
    var nodes = document.querySelectorAll('.product-form__submit, .product-form button[type="submit"], .badge, [class*="unavailable" i], [class*="sold-out" i]');
    nodes.forEach(function (n) {
      var t = (n.textContent || '').trim();
      if (/unavailable/i.test(t)) {
        n.textContent = t.replace(/(variant\s+sold\s+out\s+or\s+)?unavailable/gi, 'Sold Out').trim();
      }
    });

    // Update sold-out variant aria-labels too
    document.querySelectorAll('label[title], input[aria-label]').forEach(function (el) {
      var attr = el.hasAttribute('aria-label') ? 'aria-label' : null;
      if (attr) {
        var v = el.getAttribute(attr) || '';
        if (/unavailable/i.test(v)) {
          el.setAttribute(attr, v.replace(/(variant\s+sold\s+out\s+or\s+)?unavailable/gi, 'Sold Out'));
        }
      }
    });
  }

  // === Wire custom cart icon to open + Esc/overlay to close ===
  function wireCartDrawer() {
    var cartIcon = document.getElementById('ck-cart-icon');
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    function openDrawer(e) {
      if (e) e.preventDefault();
      if (typeof drawer.open === 'function') {
        drawer.open(cartIcon);
      } else {
        drawer.classList.add('active', 'animate');
      }
      document.body.classList.add('overflow-hidden');
    }

    function closeDrawer(e) {
      if (e) e.preventDefault();
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.classList.remove('active', 'animate');
      }
      document.body.classList.remove('overflow-hidden');
    }

    if (cartIcon && cartIcon.dataset.ckDrawerWired !== '1') {
      cartIcon.addEventListener('click', openDrawer);
      cartIcon.dataset.ckDrawerWired = '1';
    }

    // Overlay click → close
    var overlay = drawer.querySelector('#CartDrawer-Overlay, .cart-drawer__overlay');
    if (overlay && overlay.dataset.ckCloseWired !== '1') {
      overlay.addEventListener('click', closeDrawer);
      overlay.dataset.ckCloseWired = '1';
    }

    // Close button(s) inside drawer
    drawer.querySelectorAll('.drawer__close, [aria-label="Close"]').forEach(function (btn) {
      if (btn.dataset.ckCloseWired === '1') return;
      btn.addEventListener('click', closeDrawer);
      btn.dataset.ckCloseWired = '1';
    });

    // Esc key → close
    if (!document._ckDrawerEscWired) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('active')) closeDrawer();
      });
      document._ckDrawerEscWired = true;
    }
  }

  function init() {
    scrubProductDescription();
    initProductDetailsHeader();
    killViewFullDetails();
    initShippingNote();
    relabelUnavailable();
    wireCartDrawer();
    // paintColorSwatches() removed — colors now baked in server-side via swatch.liquid
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when Dawn re-renders the variant picker (after color/size change)
  document.addEventListener('shopify:section:load', init);

  // Refresh shipping progress whenever cart changes
  document.addEventListener('cart:updated', updateShippingProgress);
  document.addEventListener('cart:refresh', updateShippingProgress);
  // Hook Shopify's PubSub if available
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    try {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, updateShippingProgress);
    } catch (e) {}
  }
})();
